module.exports = __webpack_public_path__ + "img/Titan.421c813d.svg";